// extracted by mini-css-extract-plugin
export var label = "_86-1";
export var reminder = "_86-0";